import {initFormModal} from "../form/initFormModal";
import {initFormDefault} from "../form/initFormDefault";

export function initForm() {
    initFormDefault();

    if (window.innerWidth >= 1240) {
        initFormModal();
    }
}
